import { TFunction } from 'react-i18next'
import { TextEditorType } from '../../control/textEditor/TextEditor'

export interface Form {
    textEditor?: TextEditorType[]
}

export const validate = async (values: Form, t: TFunction<'translation'>) => {
    const errors: Partial<Form> = {}
    if (!values.textEditor) {
        errors.textEditor = `${t('LABEL.TEXT_REQUIRED')}` as any
    }
    return errors
}
const useTextEditor = () => {
    const handleSubmit = (values: any) => {
        console.log('submit', values)
    }

    return {
        onSubmit: handleSubmit,
    }
}

export default useTextEditor
